import { Cart } from '@diamond/shared/types';
import {
  calculateFinalPrice,
  getItemCardTrackingParams,
} from '@diamond/shared/utils';
import { TRACKING_PAGES } from '@diamond/sol-buyer/constant';

import {
  calculateCartTotal,
  calculateDiscountAmount,
  getPromoForTracking,
} from './cart-calculations';

export const buildEcommerceItem = (
  item: Cart,
  index: number,
  warehouseId: string
) => {
  const finalPrice = calculateFinalPrice(item.product, item.quantity / 1000);
  const discountAmount = calculateDiscountAmount(item.product, finalPrice);
  const promoForTracking = getPromoForTracking(item.product);

  return {
    id: item.id,
    item_id: item.product.item_code?.toString(),
    item_name: item.product.title,
    item_brand: item.product.brand_name,
    affiliation: item.product.brand_desc,
    coupon: promoForTracking?.promo_code || '',
    discount: discountAmount > 0 ? discountAmount : 0,
    index,
    item_category: item.product.category_name,
    item_category2: item.product.sub_category_name,
    item_list_id: 'cart',
    item_list_name: 'Cart',
    item_variant: item.product.type || '',
    location_id: warehouseId,
    price: finalPrice,
    quantity: item.quantity / 1000 || 1,
  };
};

export const buildViewCartPayload = (items: Cart[]) => {
  const totalValue = calculateCartTotal(items);
  const trackingItems = items.map((item, index) => ({
    index,
    ...getItemCardTrackingParams(
      item.product,
      item.quantity / 1000,
      TRACKING_PAGES.CART,
      TRACKING_PAGES.CART
    ),
  }));

  return {
    currency: 'IDR',
    value: totalValue,
    items: trackingItems,
    section_name: TRACKING_PAGES.CART,
    page_name: TRACKING_PAGES.CART,
  };
};

export const buildRemoveItemPayload = (item: Cart) => {
  const finalPrice = calculateFinalPrice(item.product, item.quantity / 1000);
  const itemValue = finalPrice * (item.quantity / 1000);
  const promoForTracking = getPromoForTracking(item.product);
  const discountAmount = calculateDiscountAmount(item.product, finalPrice);

  return {
    currency: 'IDR',
    value: itemValue,
    item_id: item.product.item_code?.toString(),
    item_name: item.product.title,
    item_brand: item.product.brand_name,
    item_category: item.product.category_name,
    item_category2: item.product.sub_category_name,
    price: finalPrice,
    quantity: item.quantity / 1000,
    discount: discountAmount > 0 ? discountAmount : null,
    promotion_id: promoForTracking
      ? `${promoForTracking.mechanism} | ${item.product.item_code}`
      : null,
    promotion_name: promoForTracking?.mechanism || null,
    section_name: TRACKING_PAGES.CART,
  };
};
